import { render, staticRenderFns } from "./404View.vue?vue&type=template&id=c050f75a&scoped=true&"
import script from "./404View.vue?vue&type=script&lang=js&"
export * from "./404View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c050f75a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c050f75a')) {
      api.createRecord('c050f75a', component.options)
    } else {
      api.reload('c050f75a', component.options)
    }
    module.hot.accept("./404View.vue?vue&type=template&id=c050f75a&scoped=true&", function () {
      api.rerender('c050f75a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/404View.vue"
export default component.exports